import { MatSelectModule } from "@angular/material/select";
import { MatMenuModule } from "@angular/material/menu";
import { MatTooltipModule } from "@angular/material/tooltip";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatNativeDateModule } from "@angular/material/core";
import { MatDialogModule } from "@angular/material/dialog";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { MatButtonToggleModule } from "@angular/material/button-toggle";
import { ReusablePaginatorComponent } from "../components/reusable-paginator/reusable-paginator.component";
import { CommonModule, DatePipe } from "@angular/common";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { IonicModule } from "@ionic/angular";
import { NgSelectModule } from "@ng-select/ng-select";
import { TranslateModule } from "@ngx-translate/core";
import { EditorModule } from "@tinymce/tinymce-angular";
import { CodeInputModule } from "angular-code-input";
import { NgChartsModule } from "ng2-charts";
import { CKEditorModule } from "ng2-ckeditor";
import { NgxFileDropModule } from "ngx-file-drop";
import { NgxPaginationModule } from "ngx-pagination";
import { CommonPipe } from "../_pipes/common.pipe";
import { FileDropDirective } from "../_helpers/file-drop.directive";
import { TwoFAComponent } from "../components/2fa/2fa.component";
import { addDiscountComponent } from "../components/add-discount/add-discount.component";
import { AddEditWarehouseComponent } from "../components/add-edit-warehouse/add-edit-warehouse.component";
import { AddFeaturedProductComponent } from "../components/add-featured-product/add-featured-product.component";
import { ApprovalWaitingComponent } from "../components/approval-waiting/approval-waiting.component";
import { CancelOrdersManagementComponent } from "../components/cancel-orders-management/cancel-orders-management.component";
import { CommonButtonComponent } from "../components/common-button/common-button.component";
import { CompanyDetailsComponent } from "../components/company-details/company-details.component";
import { CouponDetailsComponent } from "../components/coupon-details/coupon-details.component";
import { CouponManagementComponent } from "../components/coupon-management/coupon-management.component";
import { CustomersComponent } from "../components/customers/customers.component";
import { EarningsComponent } from "../components/earnings/earnings.component";
import { FeaturedProductManagementComponent } from "../components/featured-product-management/featured-product-management.component";
import { FooterComponent } from "../components/footer/footer.component";
import { ForgotPasswordComponent } from "../components/forgot-password/forgot-password.component";
import { HeaderComponent } from "../components/header/header.component";
import { InventoryManagementComponent } from "../components/inventory-management/inventory-management.component";
import { LoaderComponent } from "../components/loader/loader.component";
import { LoginComponent } from "../components/login/login.component";
import { MarketplaceDashboardComponent } from "../components/marketplace-dashboard/marketplace-dashboard.component";
import { MassUploadComponent } from "../components/mass-upload/mass-upload.component";
import { MenusComponent } from "../components/menus/menus.component";
import { MyAccountMenuComponent } from "../components/my-account-menu/my-account-menu.component";
import { MyTransactionListComponent } from "../components/my-transaction-list/my-transaction-list.component";
import { NotFoundComponent } from "../components/not-found/not-found.component";
import { NotificationCategoryComponent } from "../components/notification-category/notification-category.component";
import { NotificationManagementComponent } from "../components/notification-management/notification-management.component";
import { OrderSummaryComponent } from "../components/order-summary/order-summary.component";
import { PayoutHistoryComponent } from "../components/payout-history/payout-history.component";
import { PayoutHistoryDetailsComponent } from "../components/payoutHistoryDetails/payoutHistoryDetails.component";
import { ProductCardComponent } from "../components/product-card/product-card.component";
import { ProductConfigurationComponent } from "../components/product-configuration/product-configuration.component";
import { ProductDetailComponent } from "../components/product-detail/product-detail.component";
import { ProductDiscountDetailsComponent } from "../components/product-discount-details/product-discount-details.component";
import { ProductDiscountManagementComponent } from "../components/product-discount-management/product-discount-management.component";
import { ProductPreviewComponent } from "../components/product-preview/product-preview.component";
import { ProductsManagementComponent } from "../components/products-management/products-management.component";
import { RefundDetailsComponent } from "../components/refund-details/refund-details.component";
import { RefundComponent } from "../components/refund/refund.component";
import { RegistrationComponent } from "../components/registration/registration.component";
import { ResetPasswordComponent } from "../components/reset-password/reset-password.component";
import { ChangeReturnCancelStatusComponent } from "../components/return-cancel-status/return-cancel-status.component";
import { ReturnOrdersManagementComponent } from "../components/return-orders-management/return-orders-management.component";
import { SearchBarComponent } from "../components/search-bar/search-bar.component";
import { SettingsComponent } from "../components/settings/settings.component";
import { termsConditionsComponent } from "../components/terms-conditions/terms-conditions.component";
import { TwoFAToggleComponent } from "../components/two-fa-toggle/two-fa-toggle.component";
import { UploadImageComponent } from "../components/upload-image/upload-image.component";
import { FileUploadComponent } from "../components/file-upload/file-upload.component";
import { WarehouseManagementComponent } from "../components/warehouse-management/warehouse-management.component";
import { AddNewProductPage } from "../pages/add-new-product/add-new-product.page";
import { ProductPreviewDetailComponent } from "./../components/product-preview-detail/product-preview-detail.component";
import { TemplateDownloadComponent } from "./../components/template-download/template-download.component";
import { CapitalizeFirstDirective } from "./capitalize-first.directive";
import { ClickOutsideDirective } from "./click-outside.directive";
import { PreventNumberInputScrollDirective } from "./input-scroll-disable.directive";
import { MatButtonModule } from "@angular/material/button";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { NzCollapseModule } from "ng-zorro-antd/collapse";
import { NzDescriptionsModule } from "ng-zorro-antd/descriptions";
import { NzDividerModule } from "ng-zorro-antd/divider";
import { NzFormModule } from "ng-zorro-antd/form";
import { NzGridModule } from "ng-zorro-antd/grid";
import { NzIconModule } from "ng-zorro-antd/icon";
import { NzPaginationModule } from "ng-zorro-antd/pagination";
import { NzRateModule } from "ng-zorro-antd/rate";
import { NzSwitchModule } from "ng-zorro-antd/switch";
import { NzTableModule } from "ng-zorro-antd/table";
import { NgxCaptchaModule } from "ngx-captcha";

const NZ_MODULES = [
  NzTableModule,
  NzPaginationModule,
  NzGridModule,
  NzIconModule,
  NzCollapseModule,
  NzDescriptionsModule,
  NzFormModule,
  NzSwitchModule,
  NzDividerModule,
  NzRateModule,
];

const COMPONENTS = [
  NotificationCategoryComponent,
  LoginComponent,
  RegistrationComponent,
  NotFoundComponent,
  TwoFAComponent,
  CompanyDetailsComponent,
  ForgotPasswordComponent,
  ResetPasswordComponent,
  ProductsManagementComponent,
  FeaturedProductManagementComponent,
  HeaderComponent,
  CouponManagementComponent,
  CouponDetailsComponent,
  ProductDiscountDetailsComponent,
  RefundComponent,
  RefundDetailsComponent,
  MenusComponent,
  MyAccountMenuComponent,
  FooterComponent,
  MarketplaceDashboardComponent,
  AddNewProductPage,
  SearchBarComponent,
  MyTransactionListComponent,
  EarningsComponent,
  CustomersComponent,
  NotificationManagementComponent,
  OrderSummaryComponent,
  ProductDetailComponent,
  ProductConfigurationComponent,
  ProductPreviewComponent,
  UploadImageComponent,
  FileUploadComponent,
  MassUploadComponent,
  TemplateDownloadComponent,
  ProductCardComponent,
  InventoryManagementComponent,
  CancelOrdersManagementComponent,
  ReturnOrdersManagementComponent,
  ApprovalWaitingComponent,
  PayoutHistoryComponent,
  PayoutHistoryDetailsComponent,
  ProductDiscountManagementComponent,
  addDiscountComponent,
  AddFeaturedProductComponent,
  WarehouseManagementComponent,
  AddEditWarehouseComponent,
  termsConditionsComponent,
  ProductPreviewDetailComponent,
  ClickOutsideDirective,
  SettingsComponent,
  CapitalizeFirstDirective,
  TwoFAToggleComponent,
  LoaderComponent,
  ChangeReturnCancelStatusComponent,
  CommonButtonComponent,
];

const MODULES = [
  MatSelectModule,
  MatMenuModule,
  MatTooltipModule,
  MatDatepickerModule,
  MatNativeDateModule,
  MatDialogModule,
  MatExpansionModule, // was imported but never registered -> mat-expansion-panel rendered as a plain element
  MatProgressSpinnerModule,
  MatSlideToggleModule,
  MatButtonToggleModule,
  ReusablePaginatorComponent,
  CommonModule,
  IonicModule,
  RouterModule,
  FormsModule, // StarRatingModule,
  ReactiveFormsModule,
  CodeInputModule,
  TranslateModule,
  NgxPaginationModule,
  NgxFileDropModule, // AgmCoreModule.forRoot({
  //  apiKey: 'AIzaSyDHvKG_qCt_sT-rYBPzzIvCYy3BndUs8Ro',
  //  libraries: ['places']
  // }),
  NgChartsModule,
  CKEditorModule,
  NgSelectModule,
  EditorModule,
  NgxCaptchaModule,
  MatFormFieldModule,
  MatInputModule,
  MatButtonModule,
  MatCheckboxModule,
  MatIconModule,
  FileDropDirective,
];


@NgModule({
  imports: [...MODULES, ...NZ_MODULES],
  declarations: [
    ...COMPONENTS,
    CommonPipe,
    PreventNumberInputScrollDirective,
  ], // entryComponents: [...COMPONENTS, ...PIPES],
  exports: [...MODULES, ...NZ_MODULES, ...COMPONENTS, CommonPipe],
  providers: [DatePipe],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SharedModule {}
